import { Header, Paragraph, RichTextDisplay } from "@datagame/ui";
import { useTranslation } from "react-i18next";
import { useGlobalConfiguration } from "../../hooks/useGlobalConfiugration";

import styles from "./AllGameFinishedScreen.module.scss";

export const AllGameFinishedScreen = () => {
  const { t } = useTranslation();
  const { showCustomEndScreen, customEndScreenConfiguration } = useGlobalConfiguration();

  const shouldUseCustomEndScreen = showCustomEndScreen && customEndScreenConfiguration;

  const mainHeader = shouldUseCustomEndScreen ? customEndScreenConfiguration.mainHeader : t("common:finished.theEnd");
  const title = shouldUseCustomEndScreen ? customEndScreenConfiguration.title : t("common:finished.allGames");
  const description = shouldUseCustomEndScreen
    ? customEndScreenConfiguration.description
    : t("common:finished.description");

  const mainHeaderColor = shouldUseCustomEndScreen ? customEndScreenConfiguration.mainHeaderColor : undefined;
  const titleColor = shouldUseCustomEndScreen ? customEndScreenConfiguration.titleColor : undefined;
  const descriptionColor = shouldUseCustomEndScreen ? customEndScreenConfiguration.descriptionColor : "secondary";

  const containerStyle = shouldUseCustomEndScreen
    ? {
        backgroundColor: customEndScreenConfiguration.backgroundColor,
        backgroundImage: customEndScreenConfiguration.backgroundImage?.url
          ? `url(${customEndScreenConfiguration.backgroundImage.url})`
          : undefined,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }
    : {};

  return (
    <div className={styles.container} style={containerStyle}>
      <div className={styles.content}>
        <div className={styles.headerWrapper}>
          {shouldUseCustomEndScreen && customEndScreenConfiguration.logo && (
            <img src={customEndScreenConfiguration.logo.url} alt="client-logo" className={styles.clientLogo} />
          )}

          <Header variant="h5" style={{ color: mainHeaderColor }}>
            {mainHeader}
          </Header>
          <Header variant="h3" className={styles.header} style={{ color: titleColor }}>
            {title}
          </Header>

          {shouldUseCustomEndScreen ? (
            <div style={{ color: descriptionColor }}>
              <RichTextDisplay value={description} />
            </div>
          ) : (
            <Paragraph size="small" color="secondary">
              {description}
            </Paragraph>
          )}
        </div>
      </div>
    </div>
  );
};
